export const status = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

export const statusText = {
  ALL: 'ทั้งหมด',
  ACTIVE: 'เปิดการใช้งาน',
  INACTIVE: 'ระงับการใช้งาน',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}
